import React from "react";
import { Modal, Form, Input, Row, Col, Card, Button, Switch, Select, Avatar } from "antd";
import { DepartementService } from "../../services/DepartementService";
import Toast from "../../helpers/Toast";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { catchError } from "../../services/DaoService";
import CustomFormItem from "../utils/form/CustomFormItem";
import style from "./DepartementCreateForm.module.scss";
import { PersonnelService } from "../../services/PersonnelService";

const DepartementCreateForm = ({ visible, onCreate, onCancel }) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [creating, setCreating] = React.useState(false);
  const [validationErrors, setValidationErrors] = React.useState({});
  const [departements, setDepartements] = React.useState([]);
  const [personnels, setPersonnels] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [created, setCreated] = React.useState(false);

  React.useEffect(() => {
    if (!visible) return;
    setLoading(true);
    Promise.all([
      DepartementService.getInstance().all(),
      PersonnelService.getInstance().all()
    ]).then(([departementData, personnelData]) => {
      setDepartements(departementData.data);
      setPersonnels(personnelData.data);
    }).catch((error) => {
      catchError(error);
    }).finally(() => {
      setLoading(false);
    });
  }, [visible, created]);


  const handleSave = (isRedirection) => {
    setCreating(true);
    form
      .validateFields()
      .then((values) => {
        DepartementService.getInstance()
          .create(values)
          .then((response) => {
            Toast.success(response.message);
            form.resetFields();
            onCreate(response.data);
            if (isRedirection) {
              navigate(`/departement/${response.data.uid}`);
            } else {
              // trigger le changement de la liste des departements
              setCreated(true);
              setCreated(false);
            }
          })
          .catch((error) => {
            const errors = error.response.data;
            if (errors.validation && Object.keys(errors?.errors).length) {
              setValidationErrors(errors.errors);
            } else {
              catchError(error);
            }
          })
          .finally(() => {
            setCreating(false);
          });
      })
      .catch(() => {
        setCreating(false);
      });
  };

  return (
    <Modal
      open={visible}
      onCancel={onCancel} destroyOnHidden
      title="Créer un nouveau departement"
      footer={[
        <>
          <Row gutter={24}>
            <Col>
              <Button
                key="cancel"
                onClick={onCancel}
                className={style.ButtonNew}
              >
                Annuler
              </Button>
            </Col>
            <Col>
              <Button
                key="save-show"
                type="primary"
                loading={creating}
                onClick={() => handleSave(true)}
                className={style.ButtonNew}
              >
                Enregistrer et Afficher
              </Button>
            </Col>
            <Col>
              <Button
                key="save-again"
                type="primary"
                loading={creating}
                onClick={() => handleSave(false)}
                className={style.ButtonNew}
              >
                Enregistrer et Créer
              </Button>
            </Col>
          </Row>
        </>
      ]}
    >
      <Card style={{ marginBottom: 5 }}>
        <Form
          layout="vertical"
          form={form}
          name="createDepartementForm"
          initialValues={{
            enabled: 1,
          }}
        >
          <Row gutter={24}>
            <Col xs={24} md={24} lg={24}>
              <CustomFormItem
                label="Departement Parent"
                name="departement_id"
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              >
                <Select options={departements.map((departement) => ({
                  label: `${departement.nom} (${departement.code})`, value: departement.id
                }))} showSearch optionFilterProp="label" loading={loading} allowClear />
              </CustomFormItem>
            </Col>
            <Col xs={24} md={24} lg={12}>
              <CustomFormItem
                label="Nom"
                name="nom"
                rules={[{ required: true, message: "Veuillez saisir le nom !" }]}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              >
                <Input type="text" />
              </CustomFormItem>
            </Col>
            <Col xs={24} md={24} lg={12}>
              <CustomFormItem
                label="Code"
                name="code"
                rules={[{ required: true, message: "Veuillez saisir le code !" }]}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              >
                <Input type="text" />
              </CustomFormItem>
            </Col>
            <Col xs={24} md={24} lg={12}>
              <CustomFormItem
                label="Responsable Actuel"
                name="personnel_id"
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              >
                <Select options={personnels.map(personnel => ({
                  label: <>
                    <Avatar src={personnel.avatar_link} /> {personnel.name}
                  </>,
                  value: personnel.id,
                  name: `${personnel.name}`
                }))} showSearch optionFilterProp="name" loading={loading} />
              </CustomFormItem>
            </Col>
            <Col xs={24} md={24} lg={12}>
              <CustomFormItem
                label="Actif"
                name="enabled"
                rules={[{ required: true, message: "Veuillez saisir le enabled!" }]}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
                valuePropName="checked"
              >
                <Switch />
              </CustomFormItem>
            </Col>
          </Row>

        </Form>
      </Card>
    </Modal>
  );
};

export default DepartementCreateForm;

DepartementCreateForm.propTypes = {
  visible: PropTypes.bool,
  onCreate: PropTypes.func,
  onCancel: PropTypes.func
};
